<script setup>
import { defineEmits } from 'vue';
import { useRouter } from 'vue-router';
import { useDataStore } from '@/store/data';

const VUE_ASSETS_URL = process.env.VUE_APP_ASSETS_URL;
const router = useRouter();
const dataStore = useDataStore();

const emit = defineEmits(["done"]);

const viewMatch = () => {
  // Buscar el primer match con new=true o communicated_match=0
  const matchIndex = dataStore.matchs?.findIndex(m => m.new || !m.communicated_match) ?? -1;

  emit("done", {});
  router.push({ path: '/app/matchs/view', query: { index: matchIndex >= 0 ? matchIndex : 0 } });
};
</script>

<template>
  <div class="new-match-container">
    <!-- Header con logo -->
    <div class="header">
      <img :src="VUE_ASSETS_URL + 'logokw.png'"
           :srcset="VUE_ASSETS_URL + 'logokw.png 1x, ' + VUE_ASSETS_URL + 'logokw@2.png 2x'"
           alt="Kiwish"
           class="logo-image" />
    </div>

    <!-- Contenido principal -->
    <div class="content">
      <!-- Imagen del kiwish corazón -->
      <div class="kiwish-container">
        <img :src="VUE_ASSETS_URL + 'imgs/icons/icon_kiwish_party.png'"
             alt="Kiwish"
             class="kiwish-heart" />
      </div>

      <!-- Texto -->
      <h1 class="title">{{ $t('matchs.new.title') }}</h1>

      <!-- Botón -->
      <button class="btn-view" @click="viewMatch">
        {{ $t('matchs.new.button') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.new-match-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #EF8C8A, #FF5287);
  padding: 0 30px;
  padding-top: calc(40px + env(safe-area-inset-top, 0px));
  padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;
}

.logo-image {
  width: 140px;
  height: auto;
}

.slogan {
  font-size: 0.85rem;
  color: #F8E9BF;
  margin: 5px 0 0 0;
  font-style: italic;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.kiwish-container {
  margin-top: 30px;
  margin-bottom: 10px;
}

.kiwish-heart {
  width: 220px;
  height: 220px;
  object-fit: contain;
}

.title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #F8E9BF;
  text-align: left;
  line-height: 1.4;
  margin: 0 0 40px 0;
  max-width: 280px;
}

.btn-view {
  background: #EDEAD5;
  border: 1px solid #5A695B;
  border-radius: 16px;
  color: #FF5287;
  font-size: 1rem;
  font-weight: 600;
  padding: 15px 50px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn-view:active {
  opacity: 0.7;
}

/* Responsive */
@media (max-height: 700px) {
  .kiwish-heart {
    width: 200px;
    height: 200px;
  }
  .title {
    font-size: 1.4rem;
    margin-bottom: 30px;
  }
}

@media (max-height: 600px) {
  .kiwish-heart {
    width: 180px;
    height: 180px;
  }
  .title {
    font-size: 1.2rem;
    margin-bottom: 25px;
  }
  .header {
    padding: 10px 0;
  }
  .logo-image {
    width: 80px;
  }
}
</style>
